export default __webpack_public_path__ + "static/media/c.0d01b5cb0f626237bd201d0afcae57be.mp3";